import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    IGetRegisteredCompaniesClient,
} from 'interfaceAdapter/gatewaySchemas/IGetRegisteredCompaniesClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/supporter/registered_companies`;

export class GetRegisteredCompaniesClient implements IGetRegisteredCompaniesClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token } = input;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'X-HTTP-AUTH-TOKEN-S': token,
            'Content-Type': 'application/json',
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
